import React from 'react';
import SiteContactPage from '../components/siteContent/SiteContactPage';

const ContactPage = () => <SiteContactPage />;

export default ContactPage;
